module.exports = [
	{
		"baan_docent": "2. Docent economie ",
		"baan_anders": "1. Ambtenaar",
		"constructie": "8 Docent VO < Ambtenaar",
		"uren_docent": -7,
		"uren_anders": 28
	},
	{
		"baan_docent": "2. Docent Onderzoek & Ontwerpen",
		"baan_anders": "1. Architect",
		"constructie": "20 Docent VO > Ondernemer",
		"uren_docent": -10,
		"uren_anders": 40
	},
	{
		"baan_docent": "2. Leraar",
		"baan_anders": "1. Ambtenaar",
		"constructie": "1 Docent PO > Ambtenaar",
		"uren_docent": -16,
		"uren_anders": 18
	},
	{
		"baan_docent": "1. Leraar",
		"baan_anders": "2. Ambtenaar",
		"constructie": "2 Docent PO > Ambtenaar",
		"uren_docent": -16,
		"uren_anders": 16
	},
	{
		"baan_docent": "2. Docent geschiedenis",
		"baan_anders": "1. Ambtenaar",
		"constructie": "3 Docent VO > Ambtenaar",
		"uren_docent": -16,
		"uren_anders": 24
	},
	{
		"baan_docent": "2. Docent biologie ",
		"baan_anders": "1. Ambtenaar",
		"constructie": "5 Docent VO > Ambtenaar",
		"uren_docent": -16,
		"uren_anders": 24
	},
	{
		"baan_docent": "2. Docent scheikunde (2e graads)",
		"baan_anders": "1. Ambtenaar",
		"constructie": "7 Docent VO < Ambtenaar",
		"uren_docent": -16,
		"uren_anders": 26
	},
	{
		"baan_docent": "1. Docent Nederlands ",
		"baan_anders": "2. Lerarenopleider",
		"constructie": "12 Docent VO < L-Opleider",
		"uren_docent": -16,
		"uren_anders": 24
	},
	{
		"baan_docent": "1. Docent vo",
		"baan_anders": "2. Docent volwassenenonderwijs",
		"constructie": "18 Docent VO > Doc-Vavo",
		"uren_docent": -16,
		"uren_anders": 16
	},
	{
		"baan_docent": "2. Docent Management en Organisatie",
		"baan_anders": "1. Accountant",
		"constructie": "19 Docent VO < Ondernemer",
		"uren_docent": -16,
		"uren_anders": 24
	},
	{
		"baan_docent": "2. Docent mbo",
		"baan_anders": "1. Illustrator",
		"constructie": "22 Docent VMBO < Ondernemer",
		"uren_docent": -16,
		"uren_anders": 32
	},
	{
		"baan_docent": "2. Leraar",
		"baan_anders": "1. Onderzoeker",
		"constructie": "23 Docent PO < Onderzoeker",
		"uren_docent": -16,
		"uren_anders": 24
	},
	{
		"baan_docent": "1. Docent Frans ",
		"baan_anders": "2. Ambtenaar",
		"constructie": "6 Docent VO > Ambtenaar",
		"uren_docent": -18,
		"uren_anders": 22
	},
	{
		"baan_docent": "1. Docent natuurkunde",
		"baan_anders": "2. Lerarenopleider",
		"constructie": "10 Docent VO > L-Opleider",
		"uren_docent": -20,
		"uren_anders": 16
	},
	{
		"baan_docent": "1. Docent Nederlands ",
		"baan_anders": "2. Lerarenopleider",
		"constructie": "11 Docent VO > L-Opleider",
		"uren_docent": -20,
		"uren_anders": 12
	},
	{
		"baan_docent": "1. Docent aardrijkskunde",
		"baan_anders": "2. Onderwijsinnovator",
		"constructie": "13 Docent VO > Innovator",
		"uren_docent": -20,
		"uren_anders": 8
	},
	{
		"baan_docent": "1. Docent speciaal onderwijs",
		"baan_anders": "2. Ambtenaar",
		"constructie": "4 Docent SO > Ambtenaar",
		"uren_docent": -24,
		"uren_anders": 18
	},
	{
		"baan_docent": "1. Docent natuurkunde",
		"baan_anders": "3. Onderwijsinnovator",
		"constructie": "15 Docent VO > Innovator",
		"uren_docent": -24,
		"uren_anders": 12
	},
	{
		"baan_docent": "1. Docent aardrijkskunde",
		"baan_anders": "2. Onderwijsinnovator",
		"constructie": "16 Docent VO > Innovator",
		"uren_docent": -24,
		"uren_anders": 16
	},
	{
		"baan_docent": "1. Docent biologie ",
		"baan_anders": "2. Docent volwassenenonderwijs",
		"constructie": "17 Docent VO > Doc-Vavo",
		"uren_docent": -24,
		"uren_anders": 12
	},
	{
		"baan_docent": "1. Docent maatschappijleer",
		"baan_anders": "2. Ondernemer",
		"constructie": "21 Docent VO > Ondernemer",
		"uren_docent": -24,
		"uren_anders": 16
	},
	{
		"baan_docent": "1. Docent Engels",
		"baan_anders": "2. Onderzoeker",
		"constructie": "24 Docent VO > Onderzoeker",
		"uren_docent": -24,
		"uren_anders": 16
	},
	{
		"baan_docent": "1. Docent Frans ",
		"baan_anders": "3. Onderwijsinnovator",
		"constructie": "14 Docent VO > Innovator",
		"uren_docent": -32,
		"uren_anders": 6
	}
];


//////////////////
// WEBPACK FOOTER
// ./src/assets/data/constructie.json
// module id = 185
// module chunks = 0